import React from 'react';
import FW from '../../../config/word.json';

interface MenuItem {
  title: string;
  path: string;
  label: string;
  icon: JSX.Element;
  clickedIcon: JSX.Element;
  exact: boolean;
  isSubTab: boolean;
  isCorporateMonthly: boolean;
  isCorporatePrivate: boolean;
  isActive: boolean;
  isBusinessType: boolean;
  isShowInSubTab: boolean;
  smartTitle?: string;
  subItem: {
    title: string;
    icon: JSX.Element;
    path: string;
    exact: boolean;
    isSubBusinessType: boolean;
  }[];
}

export const SideBarItems: MenuItem[] = [
  {
    title: FW.F_W_HOME,
    path: '/home',
    label: 'home',
    icon: <img src="/images/icons/footer-home_active.svg" alt="" />,
    clickedIcon: <img src="/images/icons/footer-home.svg" alt="" />,
    exact: true,
    isSubTab: false,
    isCorporateMonthly: false,
    isCorporatePrivate: false,
    isActive: false,
    isBusinessType: false,
    isShowInSubTab: false,
    subItem: [],
  },
  {
    title: FW.F_W_RESERVATION,
    path: '/reservation/schedule',
    label: 'reservation',
    icon: <img src="/images/icons/footer-calendar_active.svg" alt="" />,
    clickedIcon: <img src="/images/icons/footer-calendar.svg" alt="" />,
    exact: true,
    isSubTab: false,
    isCorporateMonthly: false,
    isCorporatePrivate: false,
    isActive: false,
    isBusinessType: false,
    isShowInSubTab: false,
    subItem: [],
  },
  {
    title: FW.F_W_RESERVATION_LOGS,
    path: '/history',
    label: 'history',
    icon: <img src="/images/icons/footer-reader_active.svg" alt="" />,
    clickedIcon: <img src="/images/icons/footer-reader.svg" alt="" />,
    exact: true,
    isSubTab: false,
    isCorporateMonthly: false,
    isCorporatePrivate: false,
    isActive: false,
    isBusinessType: false,
    isShowInSubTab: false,
    subItem: [],
  },
  // {
  //   title: FW.F_W_REFERRAL_CODE,
  //   path: '/referralCode',
  //   label: 'referralCode',
  //   icon: <img src="/images/icons/add-user-active.svg" alt="" />,
  //   clickedIcon: <img src="/images/icons/add-user.svg" alt="" />,
  //   exact: true,
  //   isSubTab: false,
  //   isCorporateMonthly: true,
  //   isCorporatePrivate: true,
  //   isActive: true,
  //   isBusinessType: false,
  //   isShowInSubTab: false,
  // },
  // {
  //   title: FW.F_W_CREDIT_CARD_SWITCHING,
  //   path: '/creditcardSwitching',
  //   label: 'creditcardSwitching',
  //   icon: <img src="/images/icons/credit-card-active.svg" alt="" />,
  //   clickedIcon: <img src="/images/icons/credit-card.svg" alt="" />,
  //   exact: true,
  //   isSubTab: false,
  //   isCorporateMonthly: true,
  //   isCorporatePrivate: false,
  //   isActive: false,
  //   isBusinessType: false,
  //   isShowInSubTab: false,
  // },
  // {
  //   title: FW.F_W_UNPAID,
  //   path: '/unpaid',
  //   label: 'unpaid',
  //   icon: <img src="/images/icons/money-collect-active.svg" alt="" />,
  //   clickedIcon: <img src="/images/icons/money-collect.svg" alt="" />,
  //   exact: true,
  //   isSubTab: false,
  //   isCorporateMonthly: true,
  //   isCorporatePrivate: false,
  //   isActive: false,
  //   isBusinessType: false,
  //   isShowInSubTab: false,
  // },
  {
    title: FW.F_W_REQUEST_INFORMATION,
    path: '/requestInformation',
    label: 'requestInformation',
    icon: <img src="/images/icons/footer-card_active.svg" alt="" />,
    clickedIcon: <img src="/images/icons/footer-card.svg" alt="" />,
    exact: true,
    isSubTab: false,
    isCorporateMonthly: false,
    isCorporatePrivate: false,
    isActive: false,
    isBusinessType: false,
    isShowInSubTab: false,
    subItem: [],
  },
  // {
  //   title: FW.F_W_OTHERS,
  //   smartTitle: FW.F_W_SUB_RESERVATION,
  //   path: '#',
  //   label: 'others',
  //   icon: <FiMoreHorizontal />,
  //   clickedIcon: <FiMoreHorizontal />,
  //   exact: true,
  //   isSubTab: true,
  //   isCorporateMonthly: false,
  //   isCorporatePrivate: false,
  //   isActive: false,
  //   isShowInSubTab: false,
  //   subItem: [
  //     {
  //       title: FW.F_W_SUB_RESERVATION,
  //       icon: <img src="/images/icons/calendar.svg" alt="" />,
  //       path: '#',
  //       exact: true,
  //       isSubBusinessType: true,
  //     },
  //     {
  //       title: FW.F_W_SUB_RECESS,
  //       icon: <img src="/images/icons/recess.svg" alt="" />,
  //       path: '/recess',
  //       exact: true,
  //       isSubBusinessType: false,
  //     },
  //     {
  //       title: FW.F_W_REQUEST_INFORMATION,
  //       icon: <img src="/images/icons/money-collect-mobile.svg" alt="" />,
  //       path: '/requestInformation',
  //       exact: true,
  //       isSubBusinessType: false,
  //     },
  //   ],
  // },
  // {
  //   title: FW.F_W_SUB_RECESS,
  //   path: '/recess',
  //   label: 'recess',
  //   icon: <img src="/images/icons/recess.svg" alt="" />,
  //   clickedIcon: <img src="/images/icons/recess.svg" alt="" />,
  //   exact: true,
  //   isSubTab: false,
  //   isCorporateMonthly: false,
  //   isCorporatePrivate: false,
  //   isActive: false,
  //   isBusinessType: false,
  //   isShowInSubTab: true,
  // },
  {
    title: FW.F_W_OTHER_OPTIONS,
    path: '/otherOptions',
    label: 'otherOptions',
    icon: <img src="/images/icons/footer-documents_active.svg" alt="" />,
    clickedIcon: <img src="/images/icons/footer-documents.svg" alt="" />,
    exact: true,
    isSubTab: false,
    isCorporateMonthly: false,
    isCorporatePrivate: false,
    isActive: false,
    isBusinessType: false,
    isShowInSubTab: false,
    subItem: [],
  },
  {
    title: FW.F_W_LOG_OUT,
    path: '/',
    label: 'logout',
    icon: <img src="/images/icons/footer-log-out.svg" alt="" />,
    clickedIcon: <img src="/images/icons/footer-log-out.svg" alt="" />,
    exact: true,
    isSubTab: false,
    isCorporateMonthly: false,
    isCorporatePrivate: false,
    isActive: false,
    isBusinessType: false,
    isShowInSubTab: false,
    subItem: [],
  },
];
